import { render, staticRenderFns } from "./PhriContent.vue?vue&type=template&id=6acb4840&lang=pug"
import script from "./PhriContent.vue?vue&type=script&lang=js"
export * from "./PhriContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports